module.exports = __webpack_public_path__ + "static/media/king-4row.5d01933f.png";